/* eslint-disable react-hooks/exhaustive-deps */
import { GET_ME, GET_ALL_USERS } from '../../graphql/GraphqlQueries';
import { useApolloClient, useMutation, useQuery } from '@apollo/client'
import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CREATE_ROOM_MUTATION, FORWARD_MSG_MUTATION, FORWARD_FILE_MSG_MUTATION, EDIT_PARTICIPANTS_UPDATE } from '../../graphql/GraphqlMutation';
import { useDispatch, useSelector } from 'react-redux';
import { setPopup, set_global_action_data } from '../../redux/message';
import { toast } from 'react-hot-toast';
import ForwardMessageTo from '../Connect/Messages/ForwardMessageTo';
import { CREATE_UPDATE_TEAM } from '../../graphql/GraphqlMutation';

export const UserSelection = ({ type, miniList, setMiniList, ...otherprops }) => {
    const conversations = useSelector(state => state.message.conversations)
    const OnlineUsers = useSelector((state) => state.message.online_users);
    const dispatch = useDispatch();
    const Navigate = useNavigate();
    const params = useParams();
    const client = useApolloClient();
    const { me } = client.readQuery({ query: GET_ME });
    // const { users } = client.readQuery({ query: GET_ALL_USERS, variables: { company_id: me.company_id } });
    const [src_string, setSrc_string] = useState('');
    const [selected_ids, setSelected_ids] = useState([]);
    const [btnloader] = useState(false);

    const [loader, setLoader] = useState(true);
    const [users, setUsers] = useState([]);

    useQuery(GET_ALL_USERS, {
        variables: { company_id: me.company_id }, fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            setUsers(data.users);
            setLoader(false);
        }
    });

    const [updatePrivateParticipantsMethod] = useMutation(EDIT_PARTICIPANTS_UPDATE);
    const updatePrivateParti = () => {
        let old = otherprops.global_action_data.msg.secret_user
        let a_ids = selected_ids?.filter((i) => old.indexOf(i) === -1);
        let r_ids = old.filter((i) => selected_ids?.indexOf(i) === -1);
        updatePrivateParticipantsMethod({
            variables: {
                input: {
                    conversation_id: otherprops.global_action_data.msg.conversation_id,
                    msg_id: otherprops.global_action_data.msg.msg_id,
                    add_secret_user: a_ids,
                    remove_secret_user: r_ids
                }
            }
        });

        dispatch(setPopup({ data: false, key: 'private_msg_participants' }));
    }
    useEffect(() => {
        // let isMounted = true
        function initial() {
            switch (type) {
                case 'private_msg_participants':
                    setSelected_ids(miniList.map(v => v.id))
                    break;
                case 'private_msg_update':
                    setSelected_ids(otherprops.global_action_data.msg.secret_user);
                    let u = all_users.filter(v => otherprops.global_action_data.msg.secret_user.indexOf(v.id) > -1 && me.id !== v.id)
                    setMiniList(u)
                    break;
                case 'create_room':
                    setSelected_ids(miniList.map(v => v.id))
                    break;
                case 'update_room':
                    setSelected_ids(miniList.map(v => v.id))
                    break;
                case 'team_member_add':
                    setSelected_ids(otherprops.team_users)
                    break

                case 'manage_restricted': {
                    // setSelected_ids(otherprops?.team?.team_system_conversation_off_sms)
                    // setMiniList(users.filter(u => otherprops?.team?.team_system_conversation_off_sms?.indexOf(u.id) > -1).map(v => ({ ...v, display_title: v.firstname + ' ' + v.lastname })))

                    const selectedIds = Array.isArray(otherprops?.team?.team_system_conversation_off_sms)
                        ? otherprops.team.team_system_conversation_off_sms
                        : [];
                    setSelected_ids(selectedIds);
                    setMiniList(users
                        .filter(u => selectedIds.includes(u.id))
                        .map(v => ({ ...v, display_title: `${v.firstname} ${v.lastname}` }))
                    );
                    break;
                }
                default:
                    break;
            }

        }
        initial();
    }, [])

    const close = () => {
        switch (type) {
            case 'private_msg_participants':
                dispatch(set_global_action_data(null))
                dispatch(setPopup({ data: false, key: 'private_msg_participants' }));
                break;
            case 'private_msg_update':
                dispatch(set_global_action_data(null))
                dispatch(setPopup({ data: false, key: 'private_msg_participants' }));
                break;
            case 'create_room':
                Navigate(-1)
                break;
            case 'update_room':
                Navigate(-1)
                break;
            case 'direct_conv':
                otherprops.setStartDiscussion(false)
                break;
            case 'forward_msg':
                setMiniList([]);
                dispatch(setPopup({ data: false, key: 'forward_msg_popup' }));
                break;
            case 'team_member_add':
                setMiniList([]);
                otherprops.setAddMember(false);
                break;
            case 'group_member_add':
                setMiniList([]);
                otherprops.setAddMember(false);
                break;
            case 'manage_restricted':
                setMiniList([]);
                otherprops.setRestrictUser(false);
                break;
            default:
                break;
        }
    }

    const urlId = params.conversation_id

    const returnAllusers = () => {
        switch (type) {
            case 'private_msg_participants':
                return users.filter(f => f.id !== me.id).filter(u => otherprops.ThisRoom.participants.indexOf(u.id) > -1).map(v => ({ ...v, display_title: v.firstname + ' ' + v.lastname }));
            case 'private_msg_update':
                return users.filter(f => f.id !== me.id).filter(u => otherprops.ThisRoom.participants.indexOf(u.id) > -1).map(v => ({ ...v, display_title: v.firstname + ' ' + v.lastname }));
            case 'create_room':
                return users.filter(f => f.id !== me.id && f.role !== 'Guest').filter(u => otherprops.participants.indexOf(u.id) > -1).map(v => ({ ...v, display_title: v.firstname + ' ' + v.lastname }));
            case 'update_room':
                return users.filter(f => f.id !== me.id && f.role !== 'Guest').filter(u => otherprops.participants.indexOf(u.id) > -1).map(v => ({ ...v, display_title: v.firstname + ' ' + v.lastname }));
            case 'direct_conv':
                return users.filter(f => f.id !== me.id).map(v => ({ ...v, display_title: v.firstname + ' ' + v.lastname }));
            case 'forward_msg':
                const usrs = users.filter(f => f.id !== me.id).map(v => ({ ...v, display_title: v.firstname + ' ' + v.lastname }));
                const convs = conversations.filter(f => f.conversation_id !== me.id).map(v => ({ ...v, display_title: v.title, id: v.conversation_id, img: v.conv_img, fnln: v.title.slice(0, 1) })).filter(u => u.conversation_id !== urlId);
                return [...usrs, ...convs]
            case 'team_member_add':
                // .filter(u => otherprops.team_users.indexOf(u.id) === -1)
                return users.filter(f => f.id !== me.id).map(v => ({ ...v, display_title: v.firstname + ' ' + v.lastname }));
            case 'group_member_add':
                // Get all users who are already in other groups (excluding current group)
                const usersInOtherGroups = [];
                if (otherprops.allGroups && Array.isArray(otherprops.allGroups)) {
                    otherprops.allGroups.forEach(group => {
                        // Skip current group being edited
                        if (group._id !== otherprops.currentGroupId && group.users && Array.isArray(group.users)) {
                            group.users.forEach(userEmail => {
                                const user = users.find(u => u.email === userEmail);
                                if (user && !usersInOtherGroups.includes(user.id)) {
                                    usersInOtherGroups.push(user.id);
                                }
                            });
                        }
                    });
                }
                return users
                    .filter(f => f.id !== me.id) // Exclude current user
                    .filter(u => otherprops.group_users.indexOf(u.id) === -1) // Exclude users already in current group
                    .filter(u => !usersInOtherGroups.includes(u.id)) // Exclude users already in other groups
                    .map(v => ({ ...v, display_title: v.firstname + ' ' + v.lastname }));

            case 'manage_restricted':
                return users.filter(f => f.id !== me.id).filter(u => otherprops.team_users.indexOf(u.id) > -1 && otherprops?.team?.admin?.indexOf(u.id) === -1).map(v => ({ ...v, display_title: v.firstname + ' ' + v.lastname }));
            default:
                return [];
        }
    }

    // const all_users = returnAllusers();
    const all_users = useMemo(() => returnAllusers(), [type, me, users, otherprops]);

    const removeFromMini = (item) => {
        setMiniList(miniList.filter(f => f.id !== item.id));
        setSelected_ids(prev => prev?.filter(id => id !== item.id)); // Ensure selected_ids is updated
    };

    const select_user = (user) => {
        if (type === 'direct_conv') {
            // setMiniList([user]);
            // setSelected_ids([user.id])
            createDirectConversation([user.id])
        } else {
            setSelected_ids([...selected_ids, user.id])
        }
        setSrc_string('')
    }

    // const minidiv = miniList.map((item, i) =>
    const minidiv = all_users.filter(f => selected_ids?.indexOf(f.id) > -1).map((item, i) =>
        <div className={'miniItem'} key={i}>
            <div className="miniItem_image">
                <img src={item.img} alt="img" title='img' />
            </div>
            <div className={'miniItem_name'}>{item.display_title}</div>
            <div className={'miniItem_remove'} onClick={() => removeFromMini(item)}></div>
        </div>
    )

    const global_action_data = useSelector(state => state.message.global_action_data)
    const [forward] = useMutation(FORWARD_MSG_MUTATION)
    const [forwardFile] = useMutation(FORWARD_FILE_MSG_MUTATION)
    const [createDirect] = useMutation(CREATE_ROOM_MUTATION);
    const [updateTeam] = useMutation(CREATE_UPDATE_TEAM);

    const forwardAmessageMethod = async (msg_body = '') => {
        const { msg, forward_type, file, multi_file, multi_file_ids } = global_action_data;

        const selectedUsers = all_users.filter(user => selected_ids.includes(user.id));
        const newUsers = selectedUsers.filter(user => !user.conversation_id);
        const newUserIds = newUsers.map(user => user.id);

        const existingConversationIds = selected_ids.filter(id => !newUserIds.includes(id));

        try {
            let newConversationIds = [];

            // Create new conversations for users without one
            if (newUsers.length > 0) {
                const createRoomPromises = newUsers.map(user =>
                    createDirect({
                        variables: {
                            input: {
                                title: 'Personal',
                                participants: [me.id, user.id],
                                company_id: me.company_id,
                                group: 'no',
                            },
                        },
                    })
                );

                const results = await Promise.all(createRoomPromises);
                newConversationIds = results.map(res => res?.data?.create_room?.data?.conversation_id).filter(Boolean);
            }

            const conversationLists = [...existingConversationIds, ...newConversationIds];

            const input = {
                conversation_lists: conversationLists,
                // msg_type: 'text',
            };

            if (forward_type === 'file') {
                input['file_ids'] = multi_file ? multi_file_ids : [file?.id];
                input['msg_body'] = msg_body;
                input['msg_type'] = 'media_attachment';

                await forwardFile({ variables: { input } });
            } else {
                input['conversation_id'] = msg?.conversation_id;
                input['msg_id'] = msg?.msg_id;
                input['is_reply_msg'] = msg?.is_reply_msg;

                await forward({ variables: { input } });
            }

            toast.success('Message forwarded!');
            dispatch(setPopup({ data: false, key: 'forward_msg_popup' }));
        } catch (error) {
            console.error("❌ Error while forwarding message or creating conversations:", error);
            toast.error("Failed to forward message.");
        }
    };



    const createDirectConversation = async (_ids) => {
        try {
            let res = await createDirect(
                {
                    variables: {
                        input: {
                            title: 'Personal',
                            participants: [me.id, ..._ids],
                            company_id: me.company_id,
                            group: 'no'
                        }
                    }
                }
            );
            otherprops.setStartDiscussion(false)
            Navigate('/connect/' + res.data.create_room.data.conversation_id)
        } catch (error) {
            console.log(error)
        }
    }

    const SubmitAddTeamMember = async () => {
        try {
            // Update the team with the unique participants
            await updateTeam({
                variables: {
                    input: {
                        title: otherprops.team?.team_title,
                        type: 'update_conv_also',
                        participants: selected_ids,
                        team_id: otherprops.team.team_id
                    }
                }
            });

            toast.success('User updated successfully');

            // Update the team users state with the newly added users, without duplicates
            otherprops.setTeam_users(prev => [
                ...prev.filter(p => selected_ids.includes(p.id)), // Keep only selected users
                ...all_users.filter(u => selected_ids?.includes(u.id) && !prev.some(p => p.id === u.id))
            ]);

            close();
        } catch (error) {
            console.error(error);
            toast.error('Failed to update user');
        }
    };

    const SubmitAddGroupMember = async () => {
        try {
            // Add selected users to the group
            const newUsers = users.filter(u => selected_ids?.includes(u.id));
            
            // Update the group users state with the newly added users
            otherprops.setGroupUsers(prev => [
                ...prev,
                ...newUsers.filter(u => !prev.some(p => p.id === u.id))
            ]);

            toast.success('Members added successfully');
            close();
        } catch (error) {
            console.error(error);
            toast.error('Failed to add members');
        }
    };


    const [forward_extra, setforward_extra] = useState(false);
    const submit = () => {
        switch (type) {
            case 'private_msg_participants':
                setMiniList(all_users.filter(f => selected_ids?.indexOf(f.id) > -1));
                otherprops.setStep(2);
                break;
            case 'private_msg_update':
                updatePrivateParti()
                break;
            case 'create_room':
                setMiniList(all_users.filter(f => selected_ids?.indexOf(f.id) > -1));
                Navigate(-1)
                break;
            case 'update_room':
                setMiniList(all_users.filter(f => selected_ids?.indexOf(f.id) > -1));
                Navigate(-1)
                break;
            case 'direct_conv':
                createDirectConversation();
                break;
            case 'team_member_add':
                SubmitAddTeamMember();
                break;
            case 'group_member_add':
                SubmitAddGroupMember();
                break;
            case 'manage_restricted':
                // otherprops.manage_restricted(miniList.map(v => v.id));
                otherprops.manage_restricted(selected_ids);
                break;
            case 'forward_msg':
                if (global_action_data.forward_type === 'file') {
                    setforward_extra(true)
                } else {
                    forwardAmessageMethod()
                    setMiniList([]);
                }
                break;
            default:
                break;
        }

    }

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'Escape') {
                dispatch(setPopup({ data: false, key: 'forward_msg_popup' }));
                close();

            }
            // else if (event.key === 'Escape' && dispatch(setPopup({ data: true, key: 'private_msg' }))) {
            //     close();
            // }
        };
        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    const sortByName = (data) => {
        if (!Array.isArray(data)) {
            throw new TypeError('Input must be an array');
        }

        return data.sort((a, b) =>
            a.display_title.localeCompare(b.display_title, undefined, { sensitivity: 'base' })
        );
    };

    const isOnline = (v) => {
        if (type === 'forward_msg') {
            if (v.group === 'no') {
                let u = v.participants.filter(f => f !== me.id)[0]
                return OnlineUsers?.includes(u)
            }
        } else {
            return OnlineUsers?.includes(v.id)
        }
    }

    const filterUser = (_type) => {
        const rooms = all_users.filter(f => f.conversation_id)
        const user = all_users.filter(f => !f.conversation_id)

        if (_type === 'room') {
            return rooms;
        } else {
            let single = rooms?.filter(f => f.group === 'no')?.map(m => m.friend_id)
            let singleUni = user.filter(f => !single.includes(f.id))
            return singleUni;
        }
    }

    return (
        <>
            {
                forward_extra ?
                    <ForwardMessageTo forwardAmessageMethod={forwardAmessageMethod} next={selected_ids?.length > 0 ? true : false} minidiv={minidiv} close={close} setforward_extra={setforward_extra} />
                    :
                    <div className="backwrap" style={{ display: 'flex' }}>
                        <div className="participantsModal">
                            <div className="participantsModalHead">
                                <h4 className="popupTitle !text-text-headings dark:!text-white-blue">
                                    {type === 'direct_conv' ? 'Select a teammate for a direct message' :
                                        (type === 'private_msg_participants' || type === 'private_msg_edit' || type === 'private_msg_update') ? 'Select member(s) to start a private message' :
                                            type === 'forward_msg' ? 'Select member(s) to forward' :
                                                'Add members'}
                                </h4>
                                <span className="closeModal !top-[30px]" onClick={close}></span>
                            </div>
                            <div className="participantsModalBody !pl-[32px]">
                                <div className="searchParticipants !mb-0">
                                    <span className={`${type === 'direct_conv' ? '!w-full' : 'w-[calc(100%-130px)]'}`} style={{ position: 'relative', float: 'left' }}>
                                        <input
                                            type="text"
                                            className="participantsSearch"
                                            placeholder="Search user"
                                            style={{ width: '100%' }}
                                            value={src_string}
                                            onChange={(e) => setSrc_string(e.target.value)}
                                            autoFocus={true}
                                        />
                                        {src_string &&
                                            <span className="closebtn" style={{ top: '14px', right: '10px' }} onClick={() => setSrc_string('')}></span>
                                        }
                                    </span>
                                    {type !== 'direct_conv' && <button onClick={submit} className={`paricipantsSubmit ${selected_ids?.length > 0 ? '!bg-btn-primary hover:!bg-btn-hover dark:!border-border-primary' : 'inactive'}`}>
                                        {btnloader ? 'Loading...' :
                                            type === 'direct_conv' || type === 'private_msg_participants' || type === 'private_msg_edit' ? 'Start' :
                                                type === 'forward_msg' ? 'Forward' : 'Submit'}
                                    </button>
                                    }
                                    <div className="selectedParticipants">
                                        {minidiv}
                                    </div>
                                </div>
                                <div className="participantsContainer fgbh">
                                    {loader ? <div className='list_dot_loader'></div> :
                                        type === 'forward_msg' ?
                                            <>
                                                <p className="userTextListTitle">Users</p>
                                                <ListDesign all_users={filterUser('user')} select_user={select_user} isOnline={isOnline} src_string={src_string} sortByName={sortByName} selected_ids={selected_ids} />
                                                <p>Rooms</p>
                                                <ListDesign all_users={filterUser('room')} select_user={select_user} isOnline={isOnline} src_string={src_string} sortByName={sortByName} selected_ids={selected_ids} />
                                            </>
                                            :
                                            <ListDesign all_users={all_users} select_user={select_user} isOnline={isOnline} src_string={src_string} sortByName={sortByName} selected_ids={selected_ids} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </>

    )
}

const ListDesign = ({ all_users, select_user, isOnline, src_string, sortByName, selected_ids }) => {

    return (
        all_users.filter(f => f.display_title.toLowerCase().trim().indexOf(src_string.toLowerCase().trim()) > -1).length > 0 ?
            sortByName(all_users)?.filter(f => selected_ids?.indexOf(f.id) === -1 && f.display_title.toLowerCase().trim().indexOf(src_string.toLowerCase().trim()) > -1)
                .map((v, i) => (
                    <div key={'user_' + i} className="participantItem active group" onClick={() => select_user(v)}>
                        <div className={`participantImage ${isOnline(v) ? "online" : "offline"} ${(v.group && v.group === 'yes') && 'group'}`}>
                            {v.img?.includes('img.png') || v.img?.includes('feelix.jpg') ?
                                <h3 className="nameLetters group-hover:bg-btn-primary">{v.fnln.toUpperCase()}</h3>
                                :
                                <img src={v.img} alt="user" title="user" />
                            }
                        </div>
                        <p className="participantTitle !text-text-body group-hover:!text-text-light" title={v.display_title}>{v.display_title}</p>
                        <p className="participantEmail !text-text-body group-hover:!text-text-light" title={v.email}>{v.email}</p>
                    </div>
                )) :
            <div className={'_not_found'}>No data found matching the criteria.</div>
    )
}